import moment from 'moment';

export function getCacheNoExpiration(): string {
  const expiration = moment.utc().add(100, 'years');
  return expiration.toISOString();
}
